import React, { useMemo } from "react";
import PermissionGate from "../../../../components/permissionGate";
import ANALYTICS_WIDGET_PERMISSIONS from "../../../../const/analyticsPermissions";
import CampaignEffectivenessWidget from "./CampaignEffectivenessWidget.component";
import ClientSourceAnalysisWidget from "./ClientSourceAnalysisWidget.component";
import FacebookFormPerformanceWidget from "./FacebookFormPerformanceWidget.component";
import { SubTabsBar, SubTabButton, EmptyStateBox } from "./Widgets.styles";

const NoPermissionFallback = (
  <EmptyStateBox>No tienes permiso para ver esta sección.</EmptyStateBox>
);

const ClientCampaignAnalyticsDashboard = ({ companyId, startDate, endDate, channelIds }) => {
  const [campaignTab, setCampaignTab] = React.useState("campaign-effectiveness");

  const query = useMemo(
    () => ({
      companyId,
      startDate,
      endDate,
      channelIds: channelIds?.length ? channelIds : undefined,
      granularity: "daily",
    }),
    [companyId, startDate, endDate, channelIds]
  );

  return (
    <div>
      <SubTabsBar>
        <SubTabButton active={campaignTab === "campaign-effectiveness"} onClick={() => setCampaignTab("campaign-effectiveness")}>
          Efectividad de Campañas
        </SubTabButton>
        <SubTabButton active={campaignTab === "client-sources"} onClick={() => setCampaignTab("client-sources")}>
          Fuentes de Conversaciones
        </SubTabButton>
        <SubTabButton active={campaignTab === "facebook-forms"} onClick={() => setCampaignTab("facebook-forms")}>
          Formularios de Facebook
        </SubTabButton>
      </SubTabsBar>

      {campaignTab === "campaign-effectiveness" && (
        <PermissionGate
          permission={ANALYTICS_WIDGET_PERMISSIONS.CAMPAIGN_EFFECTIVENESS.permission}
          fallback={NoPermissionFallback}
        >
          <CampaignEffectivenessWidget query={query} />
        </PermissionGate>
      )}
      {campaignTab === "client-sources" && (
        <PermissionGate
          permission={ANALYTICS_WIDGET_PERMISSIONS.CLIENT_SOURCES.permission}
          fallback={NoPermissionFallback}
        >
          <ClientSourceAnalysisWidget query={query} />
        </PermissionGate>
      )}
      {campaignTab === "facebook-forms" && (
        <PermissionGate
          permission={ANALYTICS_WIDGET_PERMISSIONS.FACEBOOK_FORMS.permission}
          fallback={NoPermissionFallback}
        >
          <FacebookFormPerformanceWidget query={query} />
        </PermissionGate>
      )}
    </div>
  );
};

export default ClientCampaignAnalyticsDashboard;
